export const pickLocalized = (translations, locale, field = "title") =>
  translations?.[locale]?.[field] ?? translations?.en?.[field] ?? "";

export const pickCmsLocalized = (translations, locale, field = "title") => {
  const localized = translations?.[locale]?.[field];
  if (typeof localized === "string" && localized.trim()) return localized;
  const english = translations?.en?.[field];
  return typeof english === "string" && english.trim() ? english : "";
};

export const mediaUrl = (url) => {
  if (typeof url !== "string" || !url) return "";
  if (!url.startsWith("/")) return url;
  const origin = (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, "");
  return `${origin}${url}`;
};

export const mediaVariantUrl = (url, width) => {
  const resolved = mediaUrl(url);
  if (!resolved || !width) return resolved;
  try {
    const parsed = new URL(resolved, window.location.origin);
    if (
      parsed.origin !== window.location.origin ||
      !parsed.pathname.startsWith("/api/v1/cms/media/file/")
    ) return resolved;
    parsed.searchParams.set("width", String(width));
    parsed.searchParams.set("format", "webp");
    return parsed.toString();
  } catch {
    return resolved;
  }
};

const COLOR_HEX = {
  gray: "#8A8A8A",
  black: "#1A1A1A",
  beige: "#D9C7A7",
  navy: "#22304A",
  "off white": "#F5F1E8",
  white: "#FFFFFF",
  maroon: "#7A2E3A",
  "dusty purple": "#B98BA7",
  "dusty pink": "#E8C4C4",
};

export const colorHex = (name) =>
  COLOR_HEX[String(name).toLowerCase()] || "#C9C9C9";

export function toCardProduct(p, locale) {
  const firstMedia = p.media?.[0];
  return {
    id: p.id,
    slug: p.slug,
    name: pickLocalized(p.translations, locale),
    image: (typeof firstMedia === "string" ? firstMedia : firstMedia?.url) || "",
    price: p.base_price,
    compareAt: p.compare_at_price,
    colors: (Array.isArray(p.colors) ? p.colors : []).map(colorHex),
    meta: (p.brand || "").toUpperCase(),
    isDemo: false,
    badge: p.compare_at_price ? "sale" : p.new_arrival ? "new" : null,
    stockState: p.stock_state,
    href: `/product/${p.slug}`,
  };
}

export function toCardCategory(c, locale) {
  const brandName = c.slug === "skinfitic" ? "SKINTIFIC" : pickLocalized(c.translations, locale);
  return {
    id: c.id,
    slug: c.slug,
    image: c.image_url || "",
    name: brandName,
  };
}
